<template>
  <div class="agenda-config-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Configurações &raquo; Configurar Agenda</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <validation-observer ref="agendaForm" v-slot="{ invalid }">
          <b-row class="mb-2">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Configurações da agenda</p>
                </div>
                <div class="content">
                  <b-row>
                    <div class="logo-container">
                      <div id="agendaLogo" class="agenda-logo rounded" title="Marca" @click="$refs.fileInput.$el.childNodes[0].click()"></div>
                      <b-button class="delete-logo" size="sm" variant="danger" v-if="((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)) && (currentLogo || logoFile || agendaForm.logo)" @click="removeLogo"><i class="far fa-trash-alt"></i></b-button>
                      <label class="cj-label d-block">Selecionar marca</label>
                      <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="logoFile" accept=".jpg, .png" placeholder="" ref="fileInput" @input="logoChanged" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-file>
                    </div>
                    <b-col>
                      <label class="cj-label">Nome da agenda</label>
                      <validation-provider name="nome da agenda" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="agendaForm.name" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Duração média</label>
                      <multiselect v-model="agendaForm.duration" :options="durations" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Duração média"></multiselect>
                    </b-col>
<!--                    <b-col>-->
<!--                      <label class="cj-label">Termo da mensagem</label>-->
<!--                      <multiselect v-model="agendaForm.term" :options="terms" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Termo da mensagem"></multiselect>-->
<!--                    </b-col>-->
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Data de Abertura</label>
                      <validation-provider name="data de abertura" :rules="{ required: true }" v-slot="{ errors }">
                        <date-picker name="date" v-model="agendaForm.start_date" v-mask="'##/##/####'" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Data de Fechamento</label>
                      <validation-provider name="data de fechamento" :rules="{ required: true }" v-slot="{ errors }">
                        <date-picker name="date" v-model="agendaForm.end_date" v-mask="'##/##/####'" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Dias de funcionamento da agenda</label>
                      <ul class="days-of-week">
                        <li v-for="dow in [0, 1, 2, 3, 4, 5, 6]" :key="dow" @click="toggleDow(dow)" :class="{ 'enabled': daysOfWeekEnabled.includes(dow) }">{{ moment().weekday(dow).format('ddd') }}</li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12"><hr></b-col>
                    <b-col cols="12" md="6">
                      <label class="cj-label">Tipos de atendimento</label>
                      <validation-provider name="tipos de atendimento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.appointmentTypes" :options="appointmentTypes" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Tipos de atendimento desta agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="6">
                      <label class="cj-label">Formatos de atendimento</label>
                      <validation-provider name="formatos de atendimento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.appointmentFormats" :options="appointmentFormats" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Formatos de atendimento desta agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <table class="table table-responsive table-bordered m-0" style="display: table;">
                        <tbody>
                        <tr>
                          <td>Mostrar tipo e formato de atendimento nas marcações da agenda</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.show_appointment_type_on_calendar" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col cols="12"><hr></b-col>
                    <b-col>
                      <label class="cj-label">Profissionais que atendem nesta agenda</label>
                      <validation-provider name="profissionais" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.professionals" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Profissionais que atendem nesta agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <table class="table table-responsive table-bordered m-0" style="display: table;">
                        <tbody>
                        <tr>
                          <td>Mostrar profissional nas marcações da agenda</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.show_professional_on_calendar" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Mostrar convênio nas marcações da agenda</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.show_health_plan_on_calendar" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(agendaForm.id == null && canAdd) || (agendaForm.id != null && (canEdit || canRemove))">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda" :disabled="!canPerformAction || !((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">Salvar</b-button>
                  <b-button variant="danger" v-if="agendaForm.id != null && canRemove" @click="deleteAgenda">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Unidade de referência</p>
                  </div>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col cols="12" md="4" class="mb-3">
                      <label class="cj-label">Unidade</label>
                      <validation-provider name="unidade" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.unit" :options="units" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Unidade" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" class="mb-3">
                      <table class="table table-responsive table-bordered m-0" style="display: table;">
                        <tbody>
                        <tr>
                          <td>Ocultar endereço nas mensagens</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.hide_address_on_messages" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Personalizar endereço desta agenda</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.has_address" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                  <div v-if="agendaForm.has_address">
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Telefone</label>
                        <b-form-input type="text" v-model="agendaForm.address.telephone" v-mask="(agendaForm.address.telephone != null && agendaForm.address.telephone.length == 15)?'(##) #####-####':'(##) ####-#####'" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Celular / Whatsapp</label>
                        <b-form-input type="text" v-model="agendaForm.address.cellphone" v-mask="'(##) #####-####'" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">CEP</label>
                        <validation-provider name="cep" :rules="{ required: agendaForm.has_address }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="agendaForm.address.zip_code" v-mask="'#####-###'" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" v-on:blur="findCep(agendaForm.address.zip_code)"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="8">
                        <label class="cj-label">Endereço</label>
                        <validation-provider name="endereço" :rules="{ required: agendaForm.has_address }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="agendaForm.address.address" ref="address" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Número</label>
                        <validation-provider name="número" :rules="{ required: agendaForm.has_address }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="agendaForm.address.number" ref="number" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Complemento</label>
                        <b-form-input type="text" v-model="agendaForm.address.complement" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Bairro</label>
                        <validation-provider name="bairro" :rules="{ required: agendaForm.has_address }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="agendaForm.address.neighborhood" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Cidade</label>
                        <validation-provider name="cidade" :rules="{ required: agendaForm.has_address }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="agendaForm.address.city" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Estado</label>
                        <validation-provider name="estado" :rules="{ required: agendaForm.has_address }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="agendaForm.address.state" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div class="footer" v-if="((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda" :disabled="!canPerformAction && ((agendaForm.id == null && !canAdd) || (agendaForm.id != null && !canEdit))">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Configuração de horários</p>
                </div>
                <div class="content">
                  <b-row class="m-0">
                    <b-col cols="12" md="auto" v-for="dow in daysOfWeekEnabled" :key="dow" style="flex: 1;" class="p-0">
                    <div class="box-cj mb-0">
                      <div class="header text-center">
                        <p class="title">{{ moment().weekday(dow).format('dddd') }}</p>
                      </div>
                      <div class="content">
                        <b-row>
                          <b-col>
                            <label class="cj-label">Horário de Início</label>
                            <validation-provider name="horário de início" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }" :bails="false">
                              <b-form-input type="text" v-model="getScheduleByDow(dow).start_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <label class="cj-label">Horário de Término</label>
                            <validation-provider name="horário de término" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }" :bails="false">
                              <b-form-input type="text" v-model="getScheduleByDow(dow).end_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <div class="text-center" v-if="getBreaks(dow).length > 0">
                          <hr>
                          <small>Intervalos</small><br/>
                          <ul class="breaks mb-0">
                            <li v-for="(brk, index) in getBreaks(dow)" :key="index" @click="removeBreak(brk.id)">
                              <i class="far fa-stopwatch"></i> {{ brk.start_time }} - {{ brk.end_time }}
                              <div class="remove" v-if="((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">
                                <i class="far fa-trash-alt mr-2"></i> Clique para remover
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="footer" v-if="(agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)">
                        <b-button variant="success" @click="openModalBreak(dow)" block :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">Novo intervalo</b-button>
                      </div>
                    </div>
                  </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda" :disabled="!canPerformAction && ((agendaForm.id == null && !canAdd) || (agendaForm.id != null && !canEdit))">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Agendamento Online</p>

                    <div>
                      <a :href="aolUrl + agendaForm.id" v-if="agendaForm.online_scheduling" target="_blank" class="mr-3"><i class="far fa-link"></i></a>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="agendaForm.online_scheduling" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" v-if="agendaForm.online_scheduling">
                  <b-row class="mb-3">
                    <b-col cols="4">
                      <label class="cj-label">Tipo de período aberto para agendamento</label>
                      <validation-provider name="tipo de período aberto para agendamento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.online_scheduling_period_type" :options="onlineSchedulingPeriodOptions" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <template v-if="agendaForm.online_scheduling_period_type && agendaForm.online_scheduling_period_type.value == 'days'">
                      <b-col>
                        <label class="cj-label">Quantidade de dias abertos</label>
                        <validation-provider name="quantidade de dias abertos" :rules="{ required: true, between:[1,120] }" v-slot="{ errors }">
                          <b-form-input type="number" min="1" step="1" max="120" v-model="agendaForm.online_scheduling_period" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </template>
                    <template v-else-if="agendaForm.online_scheduling_period_type && agendaForm.online_scheduling_period_type.value == 'dates'">
                      <b-col>
                        <label class="cj-label">Data de Abertura</label>
                        <validation-provider name="data de abertura" :rules="{ required: true }" v-slot="{ errors }">
                          <date-picker name="date" v-model="agendaForm.online_scheduling_period_start_date" v-mask="'##/##/####'" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Data de Fechamento</label>
                        <validation-provider name="data de fechamento" :rules="{ required: true }" v-slot="{ errors }">
                          <date-picker name="date" v-model="agendaForm.online_scheduling_period_end_date" v-mask="'##/##/####'" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </template>
                    <b-col>
                      <label class="cj-label">Quantidade de agendamentos por escala</label>
                      <validation-provider name="quantidade de agendamentos por escala" :rules="{ required: true, between:[1,50] }" v-slot="{ errors }">
                        <b-form-input type="number" min="1" step="1" max="50" v-model="agendaForm.online_scheduling_schedule_amount" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="m-0 mb-3">
                    <b-col cols="12" md="auto" v-for="dow in daysOfWeekEnabled" :key="dow" style="flex: 1;" class="p-0">
                      <div class="box-cj mb-0">
                        <div class="header text-center">
                          <p class="title">{{ moment().weekday(dow).format('dddd') }}</p>
                        </div>
                        <div class="content">
                          <div class="text-center">
                            <ul class="breaks mb-0" v-if="getOnlineSchedules(dow).length > 0">
                              <li v-for="(osch, index) in getOnlineSchedules(dow)" :key="index" @click="editOnlineSchedule(osch)">
                                <i class="far fa-stopwatch"></i> {{ osch.start_time }} - {{ osch.end_time }}
                                <div class="remove" v-if="((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">
                                  <i class="far fa-pencil-alt mr-2"></i> Clique para editar
                                </div>
                              </li>
                            </ul>
                            <small v-else>Nenhum horário configurado</small>
                          </div>

                        </div>
                        <div class="footer" v-if="(agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)">
                          <b-button variant="success" @click="openModalOnlineSchedule(dow)" block>Nova escala</b-button>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
<!--                    TODO finalizar e habilitar?-->
                    <b-col cols="12" md="4" v-if="false">
                      <label class="cj-label">Exibição dos horários</label>
                      <validation-provider name="exibição dos horários" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.online_scheduling_show_week" :options="showWeekOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Campos de preenchimento obrigatório para o agendamento online</label>
                      <validation-provider name="campos de preenchimento obrigatório para o agendamento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="agendaForm.online_scheduling_required_fields" :options="onlineSchedulingRequiredFieldsOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Campos de preenchimento obrigatório para o agendamento online" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col cols="12" md="4" v-if="agendaForm.appointmentFormats.filter(item => (item.name !== 'Online')).length > 0">
                      <label class="cj-label">Valor da consulta presencial</label>
                      <validation-provider name="valor da consulta presencial" :rules="{ required: true, moneyGreaterThanOne:true }" v-slot="{ errors }">
                        <money v-model="agendaForm.presential_value" class="form-control mb-2" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="4" v-if="agendaForm.appointmentFormats.filter(item => (item.name === 'Online')).length > 0">
                      <label class="cj-label">Valor da consulta online</label>
                      <validation-provider name="valor da consulta online" :rules="{ required: true, moneyGreaterThanOne:true }" v-slot="{ errors }">
                        <money v-model="agendaForm.online_value" class="form-control mb-2" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row v-if="unitsWithChargingEnabled.length > 0 && agendaForm.unit != null && unitsWithChargingEnabled.indexOf(agendaForm.unit.value) >= 0">
                    <b-col cols="12" class="mb-3">
                      <table class="table table-responsive table-bordered m-0" style="display: table;">
                        <tbody>
                        <tr>
                          <td>Habilitar cobrança de agendamentos</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.online_charging" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                    <b-col cols="12" v-if="agendaForm.online_charging">
                      <b-row class="mb-2">
                        <b-col cols="12" md="4" v-if="agendaForm.appointmentFormats.filter(item => (item.name !== 'Online')).length > 0">
                          <label class="cj-label mb-1">Consulta presencial</label>
                          <div>
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.charge_to_schedule_presential" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label><span class="charge-to-schedule-label">Registrar agendamento mediante pagamento</span></label>
                              </div>
                            </div>
                          </div>
                        </b-col>
                        <b-col cols="12" md="4" v-if="agendaForm.appointmentFormats.filter(item => (item.name === 'Online')).length > 0">
                          <label class="cj-label mb-1">Consulta online</label>
                          <div>
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="agendaForm.charge_to_schedule_online" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                              <div class="state p-success">
                                <label><span class="charge-to-schedule-label">Registrar agendamento mediante pagamento</span></label>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="12" md="4">
                          <label class="cj-label">Formas de Pagamento</label>
                          <validation-provider name="formas de pagamento" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="agendaForm.charge_payment_methods" :options="paymentMethods" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Formas de pagamento" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col cols="12" md="8" offset-md="2" class="text-center">
                      <span>Para habilitar a cobrança de agendamentos, a unidade da agenda deve ter um meio de pagamento integrado cadastrado e habilitado. Para cadastrar/atualizar as unidades, <router-link tag="a" to="/configuracoes/unidades">clique aqui.</router-link></span>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="agendaForm.online_scheduling && ((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda" :disabled="!canPerformAction && ((agendaForm.id == null && !canAdd) || (agendaForm.id != null && !canEdit))">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Políticas de cancelamento, reagendamento e não comparecimento</p>
                    <div>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="agendaForm.has_policies" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" v-if="agendaForm.has_policies">
                  <b-row>
                    <b-col>
                      <label class="cj-label">Descrição</label>
                      <b-textarea rows="5" v-model="agendaForm.policies" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))"></b-textarea>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="agendaForm.has_policies && ((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Whatsapp</p>
                  </div>
                </div>
                <div class="content">
                  <div>
                    <b-row class="mb-2" v-if="user != null && (helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR')">
                      <b-col v-if="whatsapps.length > 1 || (!enable_system_whatsapps && whatsapps.length > 0)">
                        <label class="cj-label">Conta de Whatsapp para envio de mensagens</label>
                        <validation-provider name="conta de Whatsapp para envio de mensagens" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="agendaForm.whatsapp" :options="whatsapps" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Conta de Whatsapp" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col v-else class="text-center mb-2">
                        <span>Sua conta não possui um número de Whatsapp personalizado cadastrado. Para configurar <router-link tag="a" to="/configuracoes/contas-de-whatsapp/cadastrar-conta-de-whatsapp">clique aqui.</router-link></span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <table class="table table-responsive table-bordered m-0" style="display: table;">
                          <tbody>
                          <tr>
                            <td>Enviar mensagem de agendamento realizado (mensagem ao cadastrar o agendamento)</td>
                            <td class="text-center">
                              <div class="pretty p-switch p-fill">
                                <input type="checkbox" v-model="agendaForm.whatsapp_scheduled_message_enabled" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                                <div class="state p-success">
                                  <label></label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="user != null && user.person.client.show_whatsapp_options">
                      <b-col>
                        <label class="cj-label">Mensagem adicional de agendamento</label>
                        <b-textarea rows="2" v-model="agendaForm.additional_schedule_message" maxlength="130" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder='Ex: "Trazer exames anteriores"'></b-textarea>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Mensagem adicional de confirmação</label>
                        <b-textarea rows="2" v-model="agendaForm.additional_message" maxlength="130" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder='Ex: "Trazer exames anteriores."  "Chegar com 15 min de antecedência para preparativos."'></b-textarea>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div class="footer" v-if="((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda" :disabled="!canPerformAction && ((agendaForm.id == null && !canAdd) || (agendaForm.id != null && !canEdit))">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="helpers.isOwner() && user != null && user.person.client.enable_api">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">API</p>
                    <div>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="agendaForm.api_enabled" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" v-if="agendaForm.api_enabled">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label class="cj-label">ID da agenda</label>
                      <b-input-group v-if="agendaForm.id != null">
                        <b-form-input type="text" v-model="agendaForm.id" disabled></b-form-input>
                        <b-input-group-append>
                          <b-button @click="copyAgendaId"><i class="far fa-copy"></i></b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-input v-else type="text" placeholder="O ID da agenda será gerado após salvar as alterações" disabled></b-form-input>
                      <div>
                        <b-form-textarea class="copyAgendaIdTextArea" :value="agendaForm.id" ref="agendaId"></b-form-textarea>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>

        <div class="box-container" v-if="helpers.isOwner()">
<!--        <div class="box-container" v-if="agendaForm.permissions != []">-->
          <b-row class="mb-2">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Configuração de permissões</p>
                </div>
                <div class="content">
                  <table class="table table-striped table-responsive table-hover table-bordered mb-3" style="display: table;" v-if="professionals.length > 0">
                    <tr>
                      <th>Profissionais</th>
                      <th class="text-center" width="33%">Pode visualizar?</th>
                      <th class="text-center" width="33%">Pode gerenciar?</th>
                    </tr>
                    <tr v-for="professional in professionals" :key="professional.value">
                      <td>{{ professional.name }} {{ (helpers.getOwnerId() == professional.value)?'(Gestor)':'' }}</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="getPermissionByPersonId(professional.value).can_see" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)) || (helpers.getOwnerId() == professional.value)" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="getPermissionByPersonId(professional.value).can_manage" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)) || (helpers.getOwnerId() == professional.value)" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>

                  <table class="table table-striped table-responsive table-hover table-bordered m-0" style="display: table;" v-if="secretaries.length > 0">
                    <tr>
                      <th>Secretárias</th>
                      <th class="text-center" width="33%">Pode visualizar?</th>
                      <th class="text-center" width="33%">Pode gerenciar?</th>
                    </tr>
                    <tr v-for="secretary in secretaries" :key="secretary.value">
                      <td>{{ secretary.name }}</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="getPermissionByPersonId(secretary.value).can_see" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="getPermissionByPersonId(secretary.value).can_manage" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <table class="table table-striped table-responsive table-hover table-bordered m-0 mt-3" style="display: table;" v-if="user != null && user.person.client.enable_coordinator_profile && coordinators.length > 0">
                    <tr>
                      <th>Coordenadores</th>
                      <th class="text-center" width="33%">Pode visualizar?</th>
                      <th class="text-center" width="33%">Pode gerenciar?</th>
                    </tr>
                    <tr v-for="coordinator in coordinators" :key="coordinator.value">
                      <td>{{ coordinator.name }}</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="getPermissionByPersonId(coordinator.value).can_see" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="getPermissionByPersonId(coordinator.value).can_manage" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="footer" v-if="(agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveAgenda" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>

    <b-modal id="break-modal" class="break-modal" :modalClass="'break-modal'" @hidden="resetBreakModal">
      <template slot="modal-header">
        Adicionar novo intervalo
      </template>
      <template slot="default">
        <validation-observer ref="breakForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Horário de Início</label>
                <validation-provider name="horário de início" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="breakForm.start_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Horário de Término</label>
                <validation-provider name="horário de término" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="breakForm.end_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('break-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="success" @click="addBreak">Adicionar</b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal id="online-schedule-modal" class="online-schedule-modal" :modalClass="'online-schedule-modal'" @hidden="resetOnlineScheduleModal">
      <template slot="modal-header">
        Adicionar nova escala
      </template>
      <template slot="default">
        <validation-observer ref="onlineScheduleForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Horário de Início</label>
                <validation-provider name="horário de início" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="onlineScheduleForm.start_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Horário de Término</label>
                <validation-provider name="horário de término" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="onlineScheduleForm.end_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label class="cj-label">Convênios</label>
                <validation-provider name="convênios" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="onlineScheduleForm.health_plans" :options="healthPlans" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" :disabled="!((agendaForm.id == null && canAdd) || (agendaForm.id != null && canEdit))" placeholder="Convênios" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('online-schedule-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="danger" v-if="onlineScheduleForm.id != null" @click="removeOnlineSchedule(onlineScheduleForm)">Remover</b-button>
          <b-button variant="success" @click="addOnlineSchedule">Adicionar</b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>
</template>

<script>

  import axios from "axios";

  export default {
    data() {
      return {
        leavingPage: false,
        aolUrl: process.env.VUE_APP_AOL_URL,
        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canPerformAction: true,

        currentLogo: null,
        logoFile: null,

        user: null,

        agendaForm: {
          id: null,
          logo: null,
          delete_logo: false,
          name: '',
          duration: { value: '00:30:00', name: '30 Minutos' },
          // term: { value: 'f;consulta', name: 'Consulta' },
          start_date: this.moment().format('DD/MM/YYYY'),
          end_date: this.moment().add(1, 'years').format('DD/MM/YYYY'),
          appointmentTypes: [],
          appointmentFormats: [],
          professionals: [],
          online_scheduling: false,
          online_charging: false,
          unit: null,
          charge_payment_methods: [],
          presential_value: 0,
          charge_to_schedule_presential: true,
          online_value: 0,
          charge_to_schedule_online: true,
          online_scheduling_period_type: { value: 'days', name: 'Quantidade de dias a partir do dia atual' },
          online_scheduling_period: 30,
          online_scheduling_period_start_date:'',
          online_scheduling_period_end_date:'',
          online_scheduling_schedule_amount: 1,
          online_scheduling_show_week: { value: false, name: 'Não' },
          online_scheduling_required_fields:null,
          show_professional_on_calendar: true,
          show_appointment_type_on_calendar: true,
          show_health_plan_on_calendar: true,
          hide_address_on_messages: false,
          whatsapp_scheduled_message_enabled: true,
          has_address: false,
          address: {
            id: null,
            telephone: '',
            cellphone: '',
            zip_code: '',
            address: '',
            number: '',
            complement: null,
            neighborhood: '',
            city: '',
            state: '',
            country: 'Brazil'
          },
          whatsapp: null,
          additional_schedule_message: '',
          additional_message: '',
          api_enabled: false,
        },
        has_policies: false,
        policies: null,

        durations: [
          { value: '00:05:00', name: '5 Minutos' },
          { value: '00:10:00', name: '10 Minutos' },
          { value: '00:15:00', name: '15 Minutos' },
          { value: '00:20:00', name: '20 Minutos' },
          { value: '00:25:00', name: '25 Minutos' },
          { value: '00:30:00', name: '30 Minutos' },
          { value: '00:35:00', name: '35 Minutos' },
          { value: '00:40:00', name: '40 Minutos' },
          { value: '00:45:00', name: '45 Minutos' },
          { value: '00:50:00', name: '50 Minutos' },
          { value: '01:00:00', name: '60 Minutos' },
          { value: '01:30:00', name: '90 Minutos' },
          { value: '02:00:00', name: '120 Minutos' }
        ],

        // terms: [
        //   { value: 'f;consulta', name: 'Consulta' },
        //   { value: 'f;consulta por ordem de chegada', name: 'Consulta (Ordem de Chegada)' },
        //   { value: 'f;sessão', name: 'Sessão' },
        //   { value: 'm;exame', name: 'Exame' },
        //   { value: 'm;exame por ordem de chegada', name: 'Exame (Ordem de Chegada)' },
        //   { value: 'm;horário', name: 'Horário' }
        // ],

        permissions: [],

        breakForm: {
          id: null,
          day_of_week: null,
          start_time: null,
          end_time: null,
          type: 'BREAK',
          new: true
        },

        onlineScheduleForm: {
          id: null,
          day_of_week: null,
          start_time: null,
          end_time: null,
          health_plans: [],
          type: 'ONLINE',
          new: true
        },

        daysOfWeekEnabled: [],
        schedules: [],
        breaks: [],
        onlineSchedules: [],

        appointmentTypes: [],
        appointmentFormats: [],
        professionals: [],
        secretaries: [],
        coordinators: [],
        unitsWithChargingEnabled: [],
        units: [],
        whatsapps: [],
        enable_system_whatsapps: false,
        healthPlans: [],
        paymentMethods: [
          { value: 'credit', name: 'Cartão de crédito' },
          { value: 'pix', name: 'Pix' }
        ],
        onlineSchedulingPeriodOptions: [
          { value: 'days', name: 'Quantidade de dias abertos' },
          { value: 'dates', name: 'Datas de abertura e fechamento' }
        ],
        onlineSchedulingRequiredFieldsOptions: [
          { value: 'email', name: 'E-mail' },
          { value: 'birthday', name: 'Data de nascimento' },
          { value: 'cellphone', name: 'Celular' }
        ],

        showWeekOptions: [
          { value: true, name: 'Semana' },
          { value: false, name: 'Dia a dia' }
        ],

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        }
      }
    },
    async mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_remove');

      this.user = JSON.parse(localStorage.getItem('user'));
      console.log(this.user);
      if(this.canSee == false || (this.$route.params.id == 'nova-agenda' && this.user.person.client.mandic_campaign && this.user.person.client.mandic_campaign.subscription_active === 0)) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      for (let dow = 0; dow <= 6; dow++) {
        this.schedules.push({
          day_of_week: dow,
          start_time: '08:00',
          end_time: '18:00',
          type: 'AVAILABLE'
        });

        if (dow >= 1 && dow <= 5) {
          this.breaks.push({
            id: this.helpers.uuidv4(),
            day_of_week: dow,
            start_time: '12:00',
            end_time: '14:00',
            type: 'BREAK'
          })
        }
      }
      this.daysOfWeekEnabled = [1, 2, 3, 4, 5];

      await this.api.getAgendaConfigData(this.$route.params.id != 'nova-agenda' ? this.$route.params.id : null).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.units = [];
        this.unitsWithChargingEnabled = [];
        res.data.units.forEach(unit => {
          this.units.push({value: unit.id, name: unit.display_name + (unit.status == 'enabled' ? ' (meio de pagamento integrado habilitado)' : '')});
          if(unit.status == 'enabled') {
            this.unitsWithChargingEnabled.push(unit.id);
          }
        });

        this.healthPlans = [];
        res.data.health_plans.forEach(health_plan => {
          this.healthPlans.push({ value: health_plan.id, name: health_plan.name });
        });

        this.professionals = [];
        res.data.professionals.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});

          let defaultPermission = (this.helpers.getOwnerId() == professional.id)?true:false;
          this.permissions.push({person_id: professional.id, module: 'agenda', can_see: defaultPermission, can_manage: defaultPermission});
        });

        this.secretaries = [];
        res.data.secretaries.forEach(secretary => {
          this.secretaries.push({value: secretary.id, name: secretary.name});
          this.permissions.push({person_id: secretary.id, module: 'agenda', can_see: false, can_manage: false});
        });

        if(this.user.person.client.enable_coordinator_profile) {
          this.coordinators = [];
          res.data.coordinators.forEach(coordinator => {
            this.coordinators.push({value: coordinator.id, name: coordinator.name});
            this.permissions.push({person_id: coordinator.id, module: 'agenda', can_see: false, can_manage: false});
          });
        }

        this.enable_system_whatsapps = res.data.enable_system_whatsapps;
        this.whatsapps = this.enable_system_whatsapps ? [{ value: null, name: 'Usar contas do Consulta Já' }] : [];
        res.data.whatsapps.forEach(whatsapp => {
          this.whatsapps.push({value: whatsapp.id, name: whatsapp.name + ' - ' + whatsapp.number + (whatsapp.enabled ? '' : ' (desconectada)')});
        });

        this.appointmentTypes = [];
        res.data.appointment_types.forEach(appointmentType => {
          this.appointmentTypes.push({value: appointmentType.id, name: appointmentType.type});
        });

        this.appointmentFormats = [];
        res.data.appointment_formats.forEach(appointmentFormat => {
          this.appointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format});
        });

        if (this.$route.params.id == 'nova-agenda') {
          this.agendaForm.appointmentTypes = this.appointmentTypes;
          this.agendaForm.appointmentFormats = this.appointmentFormats;
          this.agendaForm.unit = this.units.find(d => d.value == this.user.person.client.default_unit.id);
        }
        else {
          let agendaData = res.data.agenda;
          this.agendaForm = {
            id: agendaData.id,
            logo: null,
            delete_logo: false,
            name: agendaData.name,
            duration: this.durations.find(d => d.value == agendaData.duration),
            // term: this.terms.find(t => t.value == agendaData.term),
            start_date: this.moment(agendaData.start_date).format('DD/MM/YYYY'),
            end_date: this.moment(agendaData.end_date).format('DD/MM/YYYY'),
            appointmentTypes: [],
            appointmentFormats: [],
            professionals: [],
            online_scheduling: agendaData.online_scheduling,
            online_scheduling_period_type: this.onlineSchedulingPeriodOptions.find(d => d.value == (agendaData.online_scheduling_period_start_date != null ? 'dates' : 'days')),
            online_scheduling_period: agendaData.online_scheduling_period,
            online_scheduling_period_start_date: agendaData.online_scheduling_period_start_date != null ? this.moment(agendaData.online_scheduling_period_start_date).format('DD/MM/YYYY') : '',
            online_scheduling_period_end_date: agendaData.online_scheduling_period_end_date != null ? this.moment(agendaData.online_scheduling_period_end_date).format('DD/MM/YYYY') : '',
            online_scheduling_schedule_amount: agendaData.online_scheduling_schedule_amount,
            online_scheduling_show_week: this.showWeekOptions.find(option => option.value === agendaData.online_scheduling_show_week),
            online_scheduling_required_fields: [],
            online_charging: agendaData.online_charging,
            unit: this.units.find(d => d.value == (agendaData.unit_id != null ? agendaData.unit_id : this.user.person.client.default_unit.id)),
            charge_payment_methods: [],
            presential_value: agendaData.presential_value != null ? agendaData.presential_value : 0,
            charge_to_schedule_presential: agendaData.charge_to_schedule_presential,
            online_value: agendaData.online_value != null ? agendaData.online_value : 0,
            charge_to_schedule_online: agendaData.charge_to_schedule_online,
            show_professional_on_calendar: agendaData.show_professional_on_calendar,
            show_appointment_type_on_calendar: agendaData.show_appointment_type_on_calendar,
            show_health_plan_on_calendar: agendaData.show_health_plan_on_calendar,
            hide_address_on_messages: agendaData.hide_address_on_messages,
            whatsapp_scheduled_message_enabled: agendaData.whatsapp_scheduled_message_enabled,
            has_address: agendaData.address != null,
            address: agendaData.address,
            has_policies: agendaData.policies != null,
            policies: agendaData.policies,
            whatsapp: this.whatsapps.find(d => d.value == agendaData.whatsapp_id),
            additional_schedule_message: agendaData.additional_schedule_message,
            additional_message: agendaData.additional_message,
            api_enabled: agendaData.api_enabled,
          };
          if(agendaData.address == null) {
            this.agendaForm.address = {
              id: null,
              zip_code: '',
              address: '',
              number: '',
              complement: null,
              neighborhood: '',
              city: '',
              state: '',
              country: 'Brazil'
            };
          }
          this.currentLogo = agendaData.logo;
          this.updateLogo();

          if(agendaData.online_scheduling_required_fields != null) {
            agendaData.online_scheduling_required_fields.split(';').forEach(requiredField => {
              this.agendaForm.online_scheduling_required_fields.push(this.onlineSchedulingRequiredFieldsOptions.find(d => d.value == requiredField));
            });
          }

          if(agendaData.charge_payment_methods != null) {
            agendaData.charge_payment_methods.split(';').forEach(paymentMethod => {
              this.agendaForm.charge_payment_methods.push(this.paymentMethods.find(d => d.value == paymentMethod));
            });
          }

          agendaData.appointment_types.forEach(appointmentType => {
            this.agendaForm.appointmentTypes.push({value: appointmentType.id, name: appointmentType.type});
          });

          agendaData.appointment_formats.forEach(appointmentFormat => {
            this.agendaForm.appointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format});
          });

          agendaData.professionals.forEach(professional => {
            this.agendaForm.professionals.push({value: professional.id, name: professional.name});
          });

          agendaData.permissions.forEach(permission => {
            this.updatePermissionByPersonId(permission.person_id, permission);
          });

          this.daysOfWeekEnabled = [];
          agendaData.schedules.forEach(schedule => {
            if(schedule.type == 'AVAILABLE' && !this.daysOfWeekEnabled.includes(schedule.day_of_week)) {
              this.schedules[schedule.day_of_week].start_time = schedule.start_time.substr(0, 5);
              this.schedules[schedule.day_of_week].end_time = schedule.end_time.substr(0, 5);
              this.daysOfWeekEnabled.push(schedule.day_of_week);
            }
          });

          this.daysOfWeekEnabled.sort();

          this.breaks = agendaData.schedules.filter(schedule => {
            schedule.start_time = schedule.start_time.substr(0, 5);
            schedule.end_time = schedule.end_time.substr(0, 5);
            schedule.new = false;
            return schedule.type == 'BREAK';
          });

          this.onlineSchedules = agendaData.schedules.filter(schedule => {
            schedule.start_time = schedule.start_time.substr(0, 5);
            schedule.end_time = schedule.end_time.substr(0, 5);
            schedule.new = false;

            let healthPlans = schedule.health_plans;
            schedule.health_plans = [];
            healthPlans.forEach(health_plan => {
              schedule.health_plans.push({value: health_plan.id, name: health_plan.name});
            });

            return schedule.type == 'ONLINE';
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Agenda Config Data', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.$router.push({path: '/configuracoes/agendas'}).catch(() => {});

        this.$swal('Ops...', 'Não conseguimos carregar os dados de configuração de agenda! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Agenda Config Data', err.response);
      });
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      toggleDow(dow) {
        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          if (this.daysOfWeekEnabled.includes(dow)) {
            let index = this.daysOfWeekEnabled.indexOf(dow);
            this.daysOfWeekEnabled.splice(index, 1);

            this.breaks = this.breaks.filter(brk => {
              return brk.day_of_week != dow;
            })

            this.onlineSchedules = this.onlineSchedules.filter(onlineSchedule => {
              return onlineSchedule.day_of_week != dow;
            })
          } else {
            this.daysOfWeekEnabled.push(dow);
            this.daysOfWeekEnabled.sort();
          }
        }
      },

      async saveAgenda() {
        if(!this.canPerformAction)
          return false;


        const isValid = await this.$refs.agendaForm.validate();
        if(!isValid) {
          return false;
        }
        let startDate = this.moment(this.agendaForm.start_date, 'DD/MM/YYYY'),
            endDate = this.moment(this.agendaForm.end_date, 'DD/MM/YYYY'),
            onlineSchedulingPeriodStartDate = this.agendaForm.online_scheduling_period_type.value == 'dates' ? this.moment(this.agendaForm.online_scheduling_period_start_date, 'DD/MM/YYYY') : null,
            onlineSchedulingPeriodEndDate = this.agendaForm.online_scheduling_period_type.value == 'dates' ? this.moment(this.agendaForm.online_scheduling_period_end_date, 'DD/MM/YYYY') : null;

        if(startDate.isAfter(endDate)) {
          this.$swal('Ops...', 'Data de Fechamento é inválida!', 'error');
          return false;
        }

        let requiredFields = null;
        if(this.agendaForm.online_scheduling) {
          if(onlineSchedulingPeriodStartDate) {
            if(onlineSchedulingPeriodStartDate.isAfter(onlineSchedulingPeriodEndDate)) {
              this.$swal('Ops...', 'Data de Fechamento do agendamento online é inválida!', 'error');
              return false;
            }
          }
          requiredFields = this.agendaForm.online_scheduling_required_fields.map(requiredField => {
            return requiredField.value;
          });
          if(requiredFields.indexOf('email') === -1 && requiredFields.indexOf('cellphone') === -1) {
            this.$swal('Ops...', 'O campo "E-mail" ou o campo "Celular" precisa ser obrigatório para fazer o agendamento online!', 'error');
            return false;
          }
          requiredFields = requiredFields.join(';');
        }

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          let agendaData = {
            id: this.agendaForm.id,
            name: this.agendaForm.name,
            unit_id: this.agendaForm.unit.value,
            duration: this.agendaForm.duration.value,
            // term: this.agendaForm.term.value,
            start_date: startDate.format('YYYY-MM-DD'),
            end_date: endDate.format('YYYY-MM-DD'),
            appointment_types: this.agendaForm.appointmentTypes.map(appointmentType => {
              return appointmentType.value;
            }),
            appointment_formats: this.agendaForm.appointmentFormats.map(appointmentFormat => {
              return appointmentFormat.value;
            }),
            professionals: this.agendaForm.professionals.map(professional => {
              return professional.value;
            }),
            online_scheduling: this.agendaForm.online_scheduling,
            online_scheduling_period: this.agendaForm.online_scheduling_period_type.value == 'days' ? this.agendaForm.online_scheduling_period : 0,
            online_scheduling_period_start_date: onlineSchedulingPeriodStartDate ? onlineSchedulingPeriodStartDate.format('YYYY-MM-DD') : null,
            online_scheduling_period_end_date: onlineSchedulingPeriodEndDate ? onlineSchedulingPeriodEndDate.format('YYYY-MM-DD') : null,
            online_scheduling_schedule_amount: this.agendaForm.online_scheduling_schedule_amount,
            online_scheduling_show_week: this.agendaForm.online_scheduling_show_week.value,
            online_scheduling_required_fields: requiredFields,
            online_charging: this.agendaForm.online_charging,
            charge_payment_methods: this.agendaForm.charge_payment_methods.map(paymentMethod => {
              return paymentMethod.value;
            }).join(';'),
            presential_value: this.agendaForm.presential_value,
            charge_to_schedule_presential: this.agendaForm.charge_to_schedule_presential,
            online_value: this.agendaForm.online_value,
            charge_to_schedule_online: this.agendaForm.charge_to_schedule_online,
            show_professional_on_calendar: this.agendaForm.show_professional_on_calendar,
            show_appointment_type_on_calendar: this.agendaForm.show_appointment_type_on_calendar,
            show_health_plan_on_calendar: this.agendaForm.show_health_plan_on_calendar,
            hide_address_on_messages: this.agendaForm.hide_address_on_messages,
            whatsapp_scheduled_message_enabled: this.agendaForm.whatsapp_scheduled_message_enabled,
            has_address: this.agendaForm.has_address,
            address: this.agendaForm.address,
            policies: this.agendaForm.has_policies ? this.agendaForm.policies : null,
            additional_schedule_message: this.agendaForm.additional_schedule_message,
            additional_message: this.agendaForm.additional_message,
            logo: this.agendaForm.logo,
            delete_logo: this.agendaForm.delete_logo,
            api_enabled: this.agendaForm.api_enabled
          };
          if((this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')) {
            agendaData.whatsapp_id = this.agendaForm.whatsapp ? this.agendaForm.whatsapp.value : null;
          }

          let schedulesActivated = this.schedules.filter(schedule => {
            return this.daysOfWeekEnabled.includes(schedule.day_of_week);
          });

          schedulesActivated = schedulesActivated.concat(this.breaks.map(brk => {
            if(brk.new)
              brk.id = null;

            return brk;
          }));

          agendaData.schedules = schedulesActivated.concat(this.onlineSchedules.map(schedule => {
            if(schedule.new)
              schedule.id = null;

            schedule.health_plans = schedule.health_plans.map(health_plan => {
              return health_plan.value;
            });

            return schedule;
          }));

          agendaData.permissions = this.permissions;

          if (this.agendaForm.id == null && this.canAdd) {
            this.api.storeAgenda(agendaData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 201) {
                this.$swal('Uhull \\o/', 'A agenda foi criada com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/configuracoes/agendas/'+res.data.id}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao criar a agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Store Agenda', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos criar esta agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Store Agenda', err.response);
            });
          } else {
            this.api.updateAgenda(this.agendaForm.id, agendaData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 200) {
                this.$swal('Uhull \\o/', 'A agenda foi atualizada com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao atualizar a agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Update Agenda', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos atualizar esta agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Update Agenda', err.response);
            });
          }
        }
      },

      deleteAgenda() {
        if(this.canRemove) {
          this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Excluir agenda',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              this.canPerformAction = false;
              this.eventBus.$emit('IS_LOADING', true);
              this.api.deleteAgenda(this.agendaForm.id).then(res => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                if (res.status == 204) {
                  this.$swal('Uhull \\o/', 'A agenda foi excluída com sucesso!', 'success').then(() => {
                    this.$router.push({path: '/configuracoes/agendas'}).catch(() => {});
                  });
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao excluir a agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Delete Agenda', res);
              }).catch(err => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                this.$swal('Ops...', 'Não conseguimos excluir esta agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Delete Agenda', err.response);
              });
            }
          });
        }
      },

      logoChanged() {
        this.agendaForm.logo = null;
        if (this.logoFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.agendaForm.logo = event.target.result;
            scope.updateLogo();
          };
          reader.readAsDataURL(this.logoFile);
        }
        else {
          this.updateLogo();
        }
      },

      removeLogo() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover marca',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.agendaForm.logo = null;
            this.currentLogo = null;
            this.logoFile = null;
            this.agendaForm.delete_logo = true;
            this.updateLogo();
          }
        });
      },

      updateLogo() {
        let logo = '';
        if(this.agendaForm.logo != null) {
          logo = this.agendaForm.logo;
        } else if(this.currentLogo != null) {
          logo = this.currentLogo;
        } else {
          logo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
        }
        if(document.getElementById('agendaLogo')) {
          document.getElementById('agendaLogo').style.backgroundImage = 'url("' + logo + '")';
        }
      },

      getScheduleByDow(dow) {
        return this.schedules.find(schedule => {
          return schedule.type == 'AVAILABLE' && schedule.day_of_week == dow;
        });
      },

      openModalBreak(dow) {
        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          this.breakForm.day_of_week = dow;
          this.$bvModal.show('break-modal');
        }
      },

      resetBreakModal() {
        this.breakForm = {
          id: null,
          day_of_week: null,
          start_time: null,
          end_time: null,
          type: 'BREAK',
          new: true
        };
      },

      async addBreak() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.breakForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          let breakData = this.breakForm;

          if(breakData.id == null) {
            breakData.id = this.helpers.uuidv4();

            this.breaks.push(breakData);
          } else {
            this.breaks = this.breaks.map(brk => {
              if(brk.id == breakData.id) {
                brk = breakData;
              }

              return brk;
            });
          }

          this.$bvModal.hide('break-modal');

          this.canPerformAction = true;
        }
      },

      removeBreak(id) {
        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          this.breaks = this.breaks.filter(brk => {
            return brk.id != id;
          });
        }
      },

      getBreaks(dow) {
        let breaks = this.breaks.filter(brk => {
          return brk.day_of_week == dow;
        }).sort(function(a, b) {
          if(a.start_time < b.start_time) { return -1; }
          if(a.start_time > b.start_time) { return 1; }
          return 0;
        });

        return breaks;
      },

      openModalOnlineSchedule(dow) {
        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          this.onlineScheduleForm.day_of_week = dow;
          this.$bvModal.show('online-schedule-modal');
        }
      },

      resetOnlineScheduleModal() {
        this.onlineScheduleForm = {
          id: null,
          day_of_week: null,
          start_time: null,
          end_time: null,
          health_plans: [],
          type: 'ONLINE',
          new: true
        };
      },

      editOnlineSchedule(osch) {
        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          this.onlineScheduleForm = osch;

          this.$bvModal.show('online-schedule-modal');
        }
      },

      async addOnlineSchedule() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.onlineScheduleForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          let onlineScheduleData = this.onlineScheduleForm;

          if(onlineScheduleData.id == null) {
            onlineScheduleData.id = this.helpers.uuidv4();

            this.onlineSchedules.push(onlineScheduleData);
          } else {
            this.onlineSchedules = this.onlineSchedules.map(osch => {
              if((osch.id == onlineScheduleData.id && onlineScheduleData.tempId == null) || (osch.id == null && osch.tempId == onlineScheduleData.tempId)) {
                osch = onlineScheduleData;
              }

              return osch;
            });
          }

          this.$bvModal.hide('online-schedule-modal');
          this.canPerformAction = true;
        }
      },

      removeOnlineSchedule(onlineSchedule) {
        if((this.agendaForm.id == null && this.canAdd) || (this.agendaForm.id != null && this.canEdit)) {
          this.onlineSchedules = this.onlineSchedules.filter(osch => {
            return osch.id != onlineSchedule.id
          });

          this.$bvModal.hide('online-schedule-modal');
        }
      },

      getOnlineSchedules(dow) {
        let onlineSchedules = this.onlineSchedules.filter(sch => {
          return sch.day_of_week == dow;
        }).sort(function(a, b) {
          if(a.start_time < b.start_time) { return -1; }
          if(a.start_time > b.start_time) { return 1; }
          return 0;
        });

        return onlineSchedules;
      },

      getPermissionByPersonId(personId) {
        return this.permissions.find(permission => {
          return permission.person_id == personId;
        });
      },

      updatePermissionByPersonId(personId, permissionData) {
        this.permissions = this.permissions.map(permission => {
          return (permission.person_id == personId)?permissionData:permission;
        })
      },

      findCep(value) {
        if(value == '00000-000' || value == '99999-999') {
          this.agendaForm.address.address = 'Atendimento online';
          this.agendaForm.address.number = '-';
          this.agendaForm.address.neighborhood = '-';
          this.agendaForm.address.city = '-';
          this.agendaForm.address.state = '-';
        } else if(value != null && value.length == 9) {
          axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
            if(typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.agendaForm.address.address = cepData.logradouro;
              this.agendaForm.address.neighborhood = cepData.bairro;
              this.agendaForm.address.city = cepData.localidade;
              this.agendaForm.address.state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {

              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      copyAgendaId() {
        this.$refs.agendaId.select();
        document.execCommand('copy');
        this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .agenda-config-form {
    padding: 20px 0;

    .breaks {
      li {
        position: relative;
        padding: 5px 0;
        cursor: pointer;

        .remove {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.8);
          opacity: 0;
          top: 0;
          left: 0;
          font-size: 0.8em;
          position: absolute;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.5s;
        }

        &:hover {
          .remove {
            opacity: 1;
          }
        }
      }
    }

    .logo-container {
      position: relative;
      text-align: center;

      .agenda-logo {
        cursor: pointer;
        margin-left: 15px;
        margin-right: 15px;
        width: 70px;
        height: 70px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;
      }

      .delete-logo {
        position: absolute;
        top: 0;
        right: 15px;
        padding: 0.25rem 0.45rem;
        font-size: 0.8rem;
      }
    }

    .p-switch .charge-to-schedule-label {
      font-size: 14px!important;
    }
    .copyAgendaIdTextArea {
      width: 1px;
      height: 1px;
      padding: 0;
      opacity: 0;
    }
  }
</style>